import React from "react";

import { percentageFormat } from "lib/formats";

import { Link } from "react-router-dom";

// import { darken } from "@material-ui/core/styles/colorManipulator";

import { withStyles } from "@material-ui/core/styles";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@material-ui/core";

import {
  ArrowDownward as ArrowDownwardIcon,
  ArrowUpward as ArrowUpwardIcon,
  Remove as NoChangeIcon,
} from "@material-ui/icons";


const NumberTableCell = withStyles((theme) => ({
  sizeSmall: {
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    padding: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0),
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1),
    },
  },
}))(TableCell);

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const PercTableCell = withStyles((theme) => ({
  root: {
    minWidth: 90,
    space: "nowrap",
  },
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  // root: {
  //   "&:nth-of-type(odd)": {
  //     backgroundColor: theme.palette.primary.main,
  //   },
  // },
}))(TableRow);

const CustomTable = withStyles((theme) => ({
  // root: {
  //   "&:last-child": {
  //     border: 0,
  //   },
  // },
}))(Table);

const RankingsTitle = withStyles((theme) => ({
  root: {
    textAlign: "center",
    padding: theme.spacing(1),
  },
}))(Typography);

function RankingName({ url, children }) {
  return url ? (
    <Link style={{ textDecoration: "none" }} to={url}>
      {children}
    </Link>
  ) : (
    children
  );
}

export default function MobilityRanking({ title, data }) {

  return (
    <Box p={1}>
      <TableContainer component={Box}>
        <RankingsTitle variant="subtitle2">{title}</RankingsTitle>
        <CustomTable aria-label="customized table" size="small">
          <TableBody>
            {data &&
              data.map(
                (
                  { url, name, lastChange, mobilityChange },
                  idx
                ) => {
                  return (
                    <StyledTableRow key={idx}>
                      <NumberTableCell>
                        <Typography variant="body2">{idx + 1}</Typography>
                      </NumberTableCell>
                      <StyledTableCell align="right">
                        <RankingName url={url}>
                          <Typography variant="body2">{name}</Typography>
                        </RankingName>
                      </StyledTableCell>
                      <PercTableCell align="right">
                        <Typography variant="body2">
                          {percentageFormat(mobilityChange)}
                        </Typography>
                      </PercTableCell>
                      <NumberTableCell align="right">
                        <Typography variant="body2">
                          {!lastChange ? (
                            <NoChangeIcon />
                          ) : lastChange > 0 ? (
                            <ArrowUpwardIcon />
                          ) : (
                            <ArrowDownwardIcon />
                          )}
                        </Typography>
                      </NumberTableCell>
                    </StyledTableRow>
                  );
                }
              )}
          </TableBody>
        </CustomTable>
      </TableContainer>
    </Box>
  );
}
